
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
	name: 'StepsProgress',
})
class StepsProgress extends Vue {
	@Prop({ type: Number, required: true })
	numberOfSteps: number;

	@Prop({ type: Number, required: true })
	currentStep: number;
}

export default StepsProgress;
